import { useState, useEffect } from "react";
import { Button } from "@/components/ui/button";
import { useIsIOS } from "@/hooks/useIsIOS";
import { useNotification } from "@/hooks/useNotification";
import { useTranslation } from "@/hooks/useTranslation";
import { Heading } from "@/components/ui/heading";

export function CookieConsent() {
  const [showBanner, setShowBanner] = useState(false);
  const { showNotification } = useNotification();
  const isIOS = useIsIOS();
  const { t } = useTranslation();

  useEffect(() => {
    let mounted = true;
    try {
      const consent = localStorage.getItem("cookie-consent");
      if (!consent && mounted) {
        setShowBanner(true);
      }
    } catch (error) {
      console.error("Failed to access localStorage:", error);
    }
    return () => {
      mounted = false;
    };
  }, []);

  const acceptCookies = () => {
    try {
      localStorage.setItem("cookie-consent", "accepted");
      setShowBanner(false);
    } catch (error) {
      showNotification({
        type: "error",
        message: t("cookie.error"),
      });
    }
  };

  if (!showBanner || isIOS) return null;

  return (
    <div
      role="alertdialog"
      aria-labelledby="cookie-consent-title"
      aria-describedby="cookie-consent-desc"
      className="fixed bottom-4 right-4 max-w-sm bg-background border rounded-lg p-4 shadow-lg z-50"
    >
      <div className="flex flex-col">
        <h2 className="text-lg font-semibold mb-2" id="cookie-consent-title">
          {t("cookie.title")}
        </h2>
        <p id="cookie-consent-desc" className="mb-2 text-sm text-muted-foreground">
          {t("cookie.description")}
        </p>
        <Button
          onClick={acceptCookies}
          className="whitespace-nowrap"
          aria-label="Accept cookie consent"
        >
          {t("cookie.accept")}
        </Button>
      </div>
    </div>
  );
}
